import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import classNames from 'classnames'

import * as reviews from '../../../store/reviews'

// Returns the plain-text content of an HTML string. ex:
//   'Foo <b>bar</b> baz' => 'Foo bar baz'
//   'Foo &amp; bar &lt; baz' => 'Foo & bar < baz'
//   'Foo <img src="x" onerror="alert('xss');"> bar' => 'Foo bar'
// We need this because our product reviews can contain HTML-escaped characters and
// they may not have been sanitized for XSS or other malicious content.
const htmlToText = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.documentElement.textContent
}

class ProductReviewContent extends Component {
  constructor(props) {
    super(props)

    this.state = {truncated: true}
  }

  showHideText() {
    if (this.state.truncated) {
      this.setState({truncated: false})
    } else {
      this.setState({truncated: true})
    }
  }

  wordCount() {
    let longDescription = false
    if (this.props.content.length >= 190) {
      longDescription = true
    }
    return longDescription
  }

  render() {
    const descriptionClasses = classNames('review-description', {
      'is--truncated': this.state.truncated,
    })
    const truncateClasses = classNames('review-read-more', {
      'is--hidden': !this.wordCount(),
    })
    return (
      <div className="product-review-content">
        <h2 className="review-title">{htmlToText(this.props.title)}</h2>
        <p className={descriptionClasses}>{htmlToText(this.props.content)}</p>
        <button
          className={truncateClasses}
          href=""
          onClick={() => {
            this.showHideText()
          }}
        >
          {this.state.truncated ? 'Read More' : 'Read Less'}
        </button>
      </div>
    )
  }
}

ProductReviewContent.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return {
    productReviews: reviews.productReviews(state),
  }
}

export default connect(mapStateToProps)(ProductReviewContent)
